import React, { useState } from 'react';
import "../css/blockchain.css";
import { MdOutlineLogin } from "react-icons/md";
import HealthCheck from './HealthCheck';
import { useAuth } from '../js/AuthContext';

const Blockchain = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { isLoggedIn, login } = useAuth();

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email === 'admin' && password === 'RS2bB14#?Y4_') {
            login(email);
        } else {
            setErrorMessage('Usuario o contraseña incorrectos');
        }
    };

    if (isLoggedIn) {
        return <HealthCheck />;
    }

    return (
        <div className='container-bc'>
            <div className='popup-content-login'>
                <img src='app/logoGreen.png' alt='Logo GREEN' className='logoGreen' />
                <h2>Accede a su cuenta</h2>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="email" className="form-element-label">Dirección Email</label>
                       <div>
                            <input
                            id="email"
                            name="email"
                            type="text"
                            required
                            value={email}
                            onChange={handleEmailChange}
                            className="form-element"
                            placeholder="Introduce tu email"
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="password" className="form-element-label">
                            Contraseña
                        </label>
                    </div>
                    <div>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            required
                            value={password}
                            onChange={handlePasswordChange}
                            className="form-element"
                            placeholder="Introduce tu contraseña"
                        />
                    </div>
                   <div className='button-container'>
                        <button
                            type="submit"
                            className="form-element button-large"
                        >
                        <MdOutlineLogin /> Iniciar Sesión
                        </button>
                    </div>
                </form>
                <p className='parrafo'>
                    ¿No eres miembro? Contacte con{' '}
                    <a href="mailto:green-info@hi-iberia.es" className="register-link">
                        green-info@hi-iberia.es
                    </a>
                </p>
            </div>
            <div className="logos-container-bc">
                <img src="app/ue-color.png" alt="Union" className="logo-bc" />
                <img src="app/ministerio-color.png" alt="Ministerio" className="logo-bc" />
                <img src="app/plan_recuperacion_color.png" alt="Recuperación" className="logo-bc" />
            </div>
        </div>
    );
};

export default Blockchain;
